"use client";

/* eslint-disable @typescript-eslint/no-explicit-any */
import ReactMarkdown from 'react-markdown';

interface MarkdownRendererProps {
  children: string;
  className?: string;
}

export const MarkdownRenderer = ({ children, className = "" }: MarkdownRendererProps) => {
  return (
    <div className={`prose prose-sm max-w-none ${className}`}>
      <ReactMarkdown
        components={{
          // Style links to match the theme
          a: ({ href, children, ...props }: any) => (
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#60FF8A] hover:text-[#60FF8A]/80 underline transition-colors"
              {...props}
            >
              {children}
            </a>
          ),
          // Style paragraphs
          p: ({ children, ...props }: any) => (
            <p className="text-gray-300 leading-relaxed" {...props}>
              {children}
            </p>
          ),
          // Style strong/bold text
          strong: ({ children, ...props }: any) => (
            <strong className="text-white font-semibold" {...props}>
              {children}
            </strong>
          ),
          // Style emphasis/italic text
          em: ({ children, ...props }: any) => (
            <em className="text-gray-200 italic" {...props}>
              {children}
            </em>
          ),
          // Style lists
          ul: ({ children, ...props }: any) => (
            <ul className="list-disc list-inside space-y-1 text-gray-300" {...props}>
              {children}
            </ul>
          ),
          ol: ({ children, ...props }: any) => (
            <ol className="list-decimal list-inside space-y-1 text-gray-300" {...props}>
              {children}
            </ol>
          ),
          li: ({ children, ...props }: any) => (
            <li className="text-gray-300" {...props}>
              {children}
            </li>
          ),
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
};
